import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ForgotUserNamedModel } from 'src/app/models/forgotusername.model';
import { LoginService } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.scss']
})
export class ForgotUsernameComponent {
  ForgetUsernameForm!: FormGroup;
  forgotUsername:  ForgotUserNamedModel = new ForgotUserNamedModel();
  submitted = false;

constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authservice: LoginService,
    private formBuilder: FormBuilder,
    private userservice : UserService,
  ) {}
  ngOnInit(): void {
      this.ForgetUsernameForm = this.formBuilder.group({
        EmailAddress: ['', Validators.required],
      });
    }
  
    validateUsername() {
      this.submitted = true;
    }
    onSubmit() {
    
      this.userservice.GetUserListByEmailId(this.ForgetUsernameForm.value.EmailAddress)
      .subscribe(
        (data) => {
          alert(
            'Please check your registered email for an email to know your username.'
          );
          this.router.navigate(['/authentication/login']);
        },
        (customError) => {
          alert(
            `Could not send email to your registered email account.
            ${customError.message}`
          );
        }
      );

    }
}
